/* eslint-disable react/prop-types */

import React from 'react';
import {
  MdEdit,
  MdOutlineAddBox,
  MdDelete,
  MdOutlineFileDownload
} from 'react-icons/md';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IoMdAdd, IoMdEye } from 'react-icons/io';
import { BsThreeDotsVertical } from 'react-icons/bs';

const ActionColumn = ({
  row,
  handleAction,
  cellProps,
  traceability = false
}) => {
  // Define the actions configuration dynamically
  const actionsConfig = [
    {
      condition: row.original.action?.edit === true,
      label: 'Edit',
      icon: <MdEdit />,
      onClick: () => handleAction('edit', row.original)
    },
    {
      condition:
        row.original.action?.view === true ||
        row.original.action?.view_map === true,
      label: 'View Map',
      icon: <IoMdEye />,
      onClick: () => handleAction('view', row.original)
    },
    {
      condition: row.original.action?.download_coords === true,
      label: 'Download Coordinates',
      icon: <MdOutlineFileDownload />,
      onClick: () => handleAction('downloadCoords', row.original)
    },
    {
      condition: row.original.action?.add_farmland === true,
      label: 'Add Farmland',
      icon: <IoMdAdd />,
      onClick: () => handleAction('add', row.original)
    },
    // {
    //   condition: row.original.action?.add_cultivation === true,
    //   label: 'Add Cultivation',
    //   icon: <IoMdAdd />,
    //   onClick: () => handleAction('add', row.original)
    // },
    {
      condition: row.original.action?.addTransfer === true,
      label: 'Create Transfer',
      icon: <IoMdAdd />,
      onClick: () => handleAction('addTransfer', row.original)
    },
    {
      condition: row.original.action?.addReception === true,
      label: 'Create Reception',
      icon: <IoMdAdd />,
      onClick: () => handleAction('addReception', row.original)
    },
    {
      condition: row.original.action?.update_harvest === true,
      label: 'Update actual Harvest',
      onClick: () => handleAction('add', row.original)
    },
    {
      condition:
        row.original.action?.verify === true &&
        row.original.Operator !== 'Verified',
      label: 'Verify',
      onClick: () => handleAction('verify', row.original)
    },
    {
      condition: row.original.action?.delete === true,
      label: 'Delete',
      icon: <MdDelete />,
      onClick: () => handleAction('delete', row.original)
    },
    {
      condition: row.original.action?.download === true,
      label: 'Download',
      onClick: () => handleAction('download', row.original)
    },
    {
      condition: row.original.action?.viewData === true,
      key: 'viewData',
      label: 'View',
      icon: <IoMdEye />,
      onClick: () => handleAction('viewData', row.original)
    },
    {
      condition: row.original.action?.view_details === true,
      key: 'viewData',
      label: 'View',
      onClick: () => handleAction('viewDetails', row.original)
    },
    {
      condition: row.original.action?.Deactivate === true,
      key: 'Deactivate',
      label: 'Deactivate',
      onClick: () => handleAction('Deactivate', row.original)
    },
    {
      condition: row.original.action?.export_kml === true,
      label: 'Export KML',
      icon: <MdOutlineFileDownload />,
      onClick: () =>
        handleAction('exportPolygon', { ...row.original, format: 'kml' })
    },
    {
      condition: row.original.action?.export_geojson === true,
      label: 'Export GeoJSON',
      icon: <MdOutlineFileDownload />,
      onClick: () =>
        handleAction('exportPolygon', { ...row.original, format: 'geojson' })
    },
    {
      condition: row.original.action?.export_csv === true,
      label: 'Export CSV',
      icon: <MdOutlineFileDownload />,
      onClick: () =>
        handleAction('exportPolygon', { ...row.original, format: 'csv' })
    },
    {
      condition: row.original.action?.export_excel === true,
      label: 'Export Excel',
      icon: <MdOutlineFileDownload />,
      onClick: () =>
        handleAction('exportPolygon', { ...row.original, format: 'excel' })
    },
    {
      condition: row.original.action?.Activate === true,
      key: 'Activate',
      label: 'Activate',
      onClick: () => handleAction('Activate', row.original)
    }
  ];

  // Filter actions that are allowed (where the condition is true)
  const allowedActions = actionsConfig.filter(action => action.condition);

  if (Array.isArray(row?.original?.action?.tupleLink)) {
    row.original.action.tupleLink.forEach(link => {
      allowedActions.push({
        condition: true,
        label: link.name,
        onClick: () =>
          handleAction('tupleLink', { rowData: row.original, linkData: link })
      });
    });
  }

  // If there are more than two actions, use a dropdown
  // Extract key from cellProps if provided
  const { key, ...restCellProps } = cellProps || {};

  return (
    <td {...restCellProps}>
      {Object.values(row.original.action).every(
        value => value === false
      ) ? null : Object.keys(row?.original?.action).length >
        (traceability ? 0 : 2) ? (
        <Dropdown align="end">
          <Dropdown.Toggle variant="link" size="md" style={{ padding: 0 }}>
            {traceability ? (
              <BsThreeDotsVertical className="fs--1 p-0" />
            ) : (
              <FontAwesomeIcon icon={'ellipsis-h'} className="fs--1 p-0" />
            )}
          </Dropdown.Toggle>
          <Dropdown.Menu className="border">
            {allowedActions.map((action, index) => (
              <Dropdown.Item key={index} onClick={action.onClick}>
                {action.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      ) : (
        <div className="d-flex overflow-hidden gap-2">
          {allowedActions.map((action, index) => (
            <button
              key={index}
              className="btn btn-outline-primary flex-shrink-0 btn-sm"
              onClick={action.onClick}
              title={action.label}
            >
              {action.icon || action.label}
            </button>
          ))}
        </div>
      )}
    </td>
  );
};

export default ActionColumn;
